import React, { useEffect, useState, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

function Module19() {

  // Page nav control
  const { canGoBack, setCanGoBack } = usePageControl();
  const { canContinue, setCanContinue } = usePageControl();

  useEffect(() => {
    setCanGoBack(false);
  }, [setCanGoBack]);
    
  useEffect(() => {
    setCanContinue(true);
  }, [setCanContinue]);

  // Go to next page
  const { goNext } = usePageControl();
    
  // Video Player
  const videoRef = useRef(null);
  
  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play(); // Plays the video
    }
  };

    // Go to the next page X seconds after video ends (3 of 4)
    const inlineTimeoutRef = useRef(null);
  
    const handleInlineVideoEnded = (delaySeconds = 0) => {
      /* Clear any existing inlineTimeout */
      if (inlineTimeoutRef.current) {
        clearTimeout(inlineTimeoutRef.current);
        inlineTimeoutRef.current = null;
      }
  
      if (delaySeconds > 0) {
        inlineTimeoutRef.current = setTimeout(() => {
          goNext();
          inlineTimeoutRef.current = null;
        }, delaySeconds * 1000);
      } else {
        goNext();
      }
    };
  
    /* Clear inlineTimeout if user manually navigates to new page (= unmounts) when timeout is running */
    useEffect(() => {
    return () => {
      if (inlineTimeoutRef.current) {
        clearTimeout(inlineTimeoutRef.current);
      }
    };
  }, []);



  // Timer
  const { stopTimer, timeRemaining, formatTime, isRunning } = useTimer();

  useEffect(() => {
    stopTimer();
  }, [stopTimer]);

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 
  
  // Determine which video to show
  const videoSrc = timeRemaining >= 0 ? '/videos/08-successful-close.mp4' : '/videos/08-unsuccessful-close.mp4';
  const videoSrcCaptions = timeRemaining >= 0 ? '/videos/08-successful-close.vtt' : '/videos/08-unsuccessful-close.vtt';

  return (
    <div id="module-19" className="page physical">

    {/* -- Background animation -- */}
    {/* 
    <div id="anim-dots-1" className="anim-dots"></div>
    <div id="anim-dots-2" className="anim-dots"></div>
    <div id="anim-dots-3" className="anim-dots"></div>
    <div id="anim-dots-4" className="anim-dots"></div>
    <div id="anim-dots-5" className="anim-dots"></div>
    <div id="anim-dots-6" className="anim-dots"></div> */}

        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>

      <main className="container-fluid">
          <div className="row">
              <div className="col-12">
                <div id="box-wrapper-tv">
                  <video
                      ref={videoRef}
                      controls
                      autoPlay
                      onEnded={() => handleInlineVideoEnded(3)}  /* Go to the next page X seconds after video ends */
                      controlsList="nodownload nofullscreen noremoteplayback"
                      disablePictureInPicture
                    >
                    <source src={`${videoSrc}`} type="video/mp4" />
                      Your browser does not support the video tag.
                    <track src={`${videoSrcCaptions}`} kind="subtitles" srcLang="en" label="English" default></track>
                  </video>
                </div>
              </div>
          </div>
      </main>

      <footer className="container-fluid">
        <div className="row">
          <div className="col-12">
            <PageNavigation />
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Module19;
